import React from 'react'
import cx from 'classnames'

import { Icon, MenuIcon } from 'components/shared/Icon/Icon'

import styles from './ToggleButton.module.scss'

export const ToggleButton = ({
  className = undefined,
  iconName = MenuIcon,
  onToggle,
}) => (
  <button
    className={cx(styles.button, { [className]: Boolean(className) })}
    onClick={onToggle}
  >
    <Icon className={styles.icon} icon={iconName} size={22} />
  </button>
)
